import {CommonModule} from '@angular/common';
import {AlertService} from './alert.service';
import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {AlertErrorComponent} from './alert-error.component';

@NgModule({
  declarations: [
    AlertErrorComponent
  ],
    imports: [
        CommonModule,
    ],
  providers: [
    AlertService
  ],
  schemas: [
    NO_ERRORS_SCHEMA
  ],
  exports: [
    AlertErrorComponent
  ]
})
export class AlertModule { }
